<script>
	import { postJsonData } from "../helpers.js";
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";

	let today = new Date()
	let todayString = `${today.getFullYear().toString().padStart(4, '0')}-${(today.getMonth()+1).toString().padStart(2, '0')}-${(today.getDate()).toString().padStart(2, '0')}`
	let [targetCity, targetCounty, targetState, targetIndustry, targetOrganization] = ['', '', '', 'Construction', ''];
	let [yearStart, yearEnd] = ['2010-05-01', todayString];
	let [includeFedData, includeStateJudgements, includeStateCases] = [true, true, true];
	let [inferZipcode, useAssumptions, inferByNaics] = [true, true, true];
	let [includeTables, includeSummaries, onlySigSummaries, includeTopViolTables] = [true, true, true, true];
	let [prevailingWageReport, signatoriesReport, openCasesOnly] = [false, false, false];
	let [targetCityError, targetCountyError, targetStateError, targetIndustryError, targetOrganizationError, includeFedDataError, inferZipcodeError,
		prevailingWageReportError, signatoriesReportError, openCasesOnlyError, includeTablesError, includeSummariesError,
		onlySigSummariesError, includeTopViolTablesError, useAssumptionsError, inferByNaicsError, includeStateJudgementsError, includeStateCasesError,
		yearStartError, yearEndError] = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];


	let county_city_lookup = {
		"Alameda_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"Colusa_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"Fresno_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"Kings_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"Los_Angeles_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"Merced_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"Sacramento_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"San_Diego_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"San_Francisco_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"San_Mateo_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"Santa_Clara_County": ["State","County","City","Water","School","College","Open Space","Commission",],
		"": ["State","County","City","Water","School","College","Open Space","Commission",]
	}

	let zipcodes = [] // will fill using countyChange on default
	let counties = ["Los_Angeles_County", "San_Diego_County", "Orange_County", "Riverside_County", "Santa_Clara_County", "San_Bernardino_County", "Alameda_County", "Sacramento_County", "Contra_Costa_County", "Ventura_County", "Fresno_County", "San_Francisco_County", "San_Mateo_County", "Kern_County", "San_Joaquin_County", "Sonoma_County", "Stanislaus_County", "Solano_County", "Santa_Barbara_County", "Monterey_County", "Tulare_County", "Placer_County", "Marin_County"].sort((a, b) => a.localeCompare(b))
	let states = ['California']

	let industries = ['All Construction', 'Residential Building', 'Nonresidential Building', 'Utility System', 'Land Subdivision', 
					'Highway, Street, and Bridge', 'Other Heavy and Civil', 'Foundation, Structure, and Building Exterior ', 'Building Equipment',
					'Building Finishing', 'Landscaping', 'Other Specialty Trade']
	let otherError = '';
	let searchForm;

	let submitted = false;
	let finished = false;

	let checkboxToIntParams = ['includeFedData', 'includeStateJudgements', 'includeStateCases', 'infer_zip', 'prevailing_wage_report', 'signatories_report', 'open_cases_only',
							'include_tables', 'include_summaries', 'only_sig_summaries', 'include_top_viol_tables', 'use_assumptions',
							'infer_by_naics']

	function stateChange() {
		if (targetState == "California") {
			counties = ['Alameda_County', 'Alpine_County', 'Amador_County', 'Butte_County', 'Calaveras_County', 'Colusa_County', 'Contra_Costa_County', 'Del_Norte_County', 'El_Dorado_County', 'Fresno_County', 'Glenn_County', 'Humboldt_County', 'Imperial_County', 'Inyo_County', 'Kern_County', 'Kings_County', 'Lake_County', 'Lassen_County', 'Los_Angeles_County', 'Madera_County', 'Marin_County', 'Mariposa_County', 'Mendocino_County', 'Merced_County', 'Modoc_County', 'Mono_County', 'Monterey_County', 'Napa_County', 'Nevada_County', 'Orange_County', 'Placer_County', 'Plumas_County', 'Riverside_County', 'Sacramento_County', 'San_Benito_County', 'San_Bernardino_County', 'San_Diego_County', 'San_Francisco_County', 'San_Joaquin_County', 'San_Luis_Obispo_County', 'San_Mateo_County', 'Santa_Barbara_County', 'Santa_Clara_County', 'Santa_Cruz_County', 'Shasta_County', 'Sierra_County', 'Siskiyou_County', 'Solano_County', 'Sonoma_County', 'Stanislaus_County', 'Sutter_County', 'Tehama_County', 'Trinity_County', 'Tulare_County', 'Tuolumne_County', 'Ventura_County', 'Yolo_County', 'Yuba_County']
		} else {
			counties = ["Los_Angeles_County", "San_Diego_County", "Orange_County", "Riverside_County", "Santa_Clara_County", "San_Bernardino_County", "Alameda_County", "Sacramento_County", "Contra_Costa_County", "Ventura_County", "Fresno_County", "San_Francisco_County", "San_Mateo_County", "Kern_County", "San_Joaquin_County", "Sonoma_County", "Stanislaus_County", "Solano_County", "Santa_Barbara_County", "Monterey_County", "Tulare_County", "Placer_County", "Marin_County"]
		}
		counties = counties.sort((a, b) => a.localeCompare(b));
		targetCounty = "";
		targetCity = "";
	}

	function countyChange() {
		targetCity = "";
		zipcodes = county_city_lookup[targetCounty].sort((a, b) => a.localeCompare(b));
	}

	countyChange(); // call to load zipcodes, could use svelte's $: targetCounty, countyChange()

	function handleSubmit() {
		// convert form to json
		let formData = new FormData(searchForm)
		var searchObj = {};

		checkboxToIntParams.forEach((key) => searchObj[key] = 0) //defaults
		// searchObj['all_industry_summary_block'] = false; // default

		formData.forEach((value, key) => {
			if(checkboxToIntParams.includes(key)) {
				searchObj[key] = value === 'on' ? 1 : 0; 
			// } else if (key === 'all_industry_summary_block') {
			// 	searchObj[key] = (value === 'on')
			} else {
				searchObj[key] = value;
			}
		});
		submitted = true;
		let res = postJsonData('wage-report/generate', searchObj);
		res.then(response => {console.log(response.headers.get("content-disposition")); return response.blob()}).then((resp_blob) => {
				submitted = false;
				finished = true;

				const href = URL.createObjectURL(resp_blob);
				const link = document.createElement('a');
				link.href = href;
				link.setAttribute('download', 'wage_report.html');
				document.body.appendChild(link);
				link.click();

				document.body.removeChild(link);
				URL.revokeObjectURL(href);
			}
		)
	}

	function newSearch() {
		finished = false;

		[targetCity, targetCounty, targetState, targetIndustry, targetOrganization] = ['', '', '', 'Construction', ''];
		[yearStart, yearEnd] = ['2010-05-01', todayString];
		[includeFedData, includeStateJudgements, includeStateCases] = [true, true, true];
		[inferZipcode, useAssumptions, inferByNaics] = [true, true, true];
		[includeTables, includeSummaries, onlySigSummaries, includeTopViolTables] = [true, true, true, true];
		[prevailingWageReport, signatoriesReport, openCasesOnly] = [false, false, false];
		[targetCityError, targetCountyError, targetStateError, targetIndustryError, targetOrganizationError, includeFedDataError, inferZipcodeError,
		prevailingWageReportError, signatoriesReportError, openCasesOnlyError, includeTablesError, includeSummariesError,
		onlySigSummariesError, includeTopViolTablesError, useAssumptionsError, inferByNaicsError, includeStateJudgementsError, includeStateCasesError,
		yearStartError, yearEndError] = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];

	}
</script>

<main class=background>
	<Navbar/>
	<div class="flex flex-col space-y-4 mt-10 items-center lg:flex-row lg:justify-center">
		<div class="mx-2 !mb-4 px-10 py-12 max-w-4xl w-full flex-1 card">
			<!-- Use hidden to preserve form state instead of discarding -->
			<div class="hidden md:block"> <!-- Cheap way out, especially since layout change on desktop-->
				<p class="text-2xl font-semibold text-blue-900 mb-8">Agency Agenda Search</p>
				<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
				<form method="POST" class="h-full relative" bind:this={searchForm} on:submit|preventDefault={handleSubmit}>
					<!-- <input id="csrf_token" name="csrf_token" value="" class="hidden"> -->
					<div class="flex flex-col space-y-4 text-xl">
						<div class='input w-full'>
							<div class="relative">
								<input id="target-organization" name="target_organization" bind:value={targetOrganization} placeholder="Target Organization (Optional)" class="peer z-20 placeholder:text-transparent {targetOrganizationError === '' ? '' : 'border-red-600'}"/>
								<label for="target-organization" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Target Agency (optional)</label>
							</div>
							<p class="error-text {targetOrganizationError === '' ? 'hidden' : ''}">{targetOrganizationError}</p>
						</div>
						<!--
						<fieldset class="flex space-x-4">
							<div class='input w-1/2'>
								<label class="flex space-x-2">
									<p class="my-auto">Start: </p>
									<input id="start-date" name="YEAR_START" bind:value={yearStart} placeholder="Start Date" type='date' class="input-field {yearStartError === '' ? '' : 'border-red-600'}"/>
								</label>									
								<p class='error-text {yearStartError === '' ? 'hidden' : ''}'>{yearStartError}</p>
							</div>
							<div class='input w-1/2'>
								<label class="flex space-x-2">
									<p class="my-auto">End: </p> 
									<input id="end-date" name="YEAR_END" bind:value={yearEnd} placeholder="End Date" type='date' class="input-field {yearEndError === '' ? '' : 'border-red-600'}"/>
								</label>
								<p class='error-text {yearEndError === '' ? 'hidden' : ''}'>{yearEndError}</p>
							</div>
						</fieldset>
						-->
						<div class="flex space-x-4">
							<!--
							<div class='input w-1/2'>
								<div class="relative">
									<select id="target-state" name="target_state" bind:value={targetState} on:change={stateChange} class="input-field mt-4 w-full {targetStateError === '' ? '' : 'border-red-600'}">
										<option value="">Select a State</option>
										{#each states as state}
										<option value={state}>{state.replaceAll("_", " ")}</option>
										{/each}
									</select>
									<label for="target-state" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">State</label>
								</div>
								<p class='error-text {targetStateError === '' ? 'hidden' : ''}'>{targetStateError}</p>
							</div>
							-->
							<div class='input w-1/2'>
								<div class="relative">
									<select id="target-county" name="target_county" bind:value={targetCounty} on:change={countyChange} class="input-field mt-4 w-full {targetCountyError === '' ? '' : 'border-red-600'}">
										<option value="">Select a County</option>
										{#each counties as county}
										<option value={county}>{county.replaceAll("_", " ")}</option>
										{/each}
									</select>
									<label for="target-county" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">County</label>
								</div>
								<p class='error-text {targetCountyError === '' ? 'hidden' : ''}'>{targetCountyError}</p>
							</div>
						</div>
						<div class="flex space-x-4">
							<div class='input w-1/2'>
								<div class="relative">
									<select id="target-city" name="target_city" bind:value={targetCity} class="input-field mt-4 w-full {targetCityError === '' ? '' : 'border-red-600'}">
										<option value="">Select an Agency Type</option> <!-- Zipcode is technical debt from API -->
										{#each zipcodes as zipcode}
											<option value={zipcode}>{zipcode.replaceAll("_", " ")}</option>
										{/each}
									</select>
									<label for="target-city" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">City</label>
								</div>
								<p class='error-text {targetCityError === '' ? 'hidden' : ''}'>{targetCityError}</p>
							</div>
							<div class='input w-1/2'>
								<div class="relative">
									<select id="target-industry" name="target_industry" bind:value={targetIndustry} class="input-field mt-4 w-full {targetIndustryError === '' ? '' : 'border-red-600'}">
										<option value="">Select an Industry</option>
										{#each industries as industry}
											<option value={industry}>{industry}</option>
										{/each}
									</select>
									<label for="target-industry" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Industry</label>
								</div>
								<p class='error-text {targetIndustryError === '' ? 'hidden' : ''}'>{targetIndustryError}</p>
							</div>
						</div>

						<p class="text-2xl font-semibold text-blue-900 mb-8">Subregions</p>

						<div class="flex space-x-4">
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {includeFedDataError === '' ? '' : 'border-red-600'}">
									<input id="include-fed-data" name="includeFedData" bind:checked={includeFedData} type="checkbox" class="w-5"/>
									<label for="include-fed-data">City A</label>
									<p class='error-text {includeFedDataError === '' ? 'hidden' : ''}'>{includeFedDataError}</p>
								</div>
							</div>
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {includeStateJudgementsError === '' ? '' : 'border-red-600'}">
									<input id="include-state-judgements" name="includeStateJudgements" bind:checked={includeStateJudgements} type="checkbox" class="w-5"/>
									<label for="include-state-judgements">City B</label>
									<p class='error-text {includeStateJudgementsError === '' ? 'hidden' : ''}'>{includeStateJudgementsError}</p>
								</div>
							</div>
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {includeStateCasesError === '' ? '' : 'border-red-600'}">
									<input id="include-state-cases" name="includeStateCases" bind:checked={includeStateCases} type="checkbox" class="w-5"/>
									<label for="include-state-cases">City C</label>
									<p class='error-text {includeStateCasesError === '' ? 'hidden' : ''}'>{includeStateCasesError}</p>
								</div>
							</div>
						</div>

						<p class="text-2xl font-semibold text-blue-900 mb-8">Agencies</p>

						<div class="flex space-x-4">
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {prevailingWageReportError === '' ? '' : 'border-red-600'}">
									<input id="prevailing-wage-report" name="prevailing_wage_report" bind:checked={prevailingWageReport} type="checkbox" class="w-5"/>
									<label for="prevailing-wage-report">Agency A</label>
									<p class='error-text {prevailingWageReportError === '' ? 'hidden' : ''}'>{prevailingWageReportError}</p>
								</div>
							</div>
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {inferZipcodeError === '' ? '' : 'border-red-600'}">
									<input id="infer-zipcode" name="infer_zip" bind:checked={inferZipcode} type="checkbox" class="w-5"/>
									<label for="infer-zipcode">Agency B</label>
									<p class='error-text {inferZipcodeError === '' ? 'hidden' : ''}'>{inferZipcodeError}</p>
								</div>
							</div>
							<!-- <div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {allIndustrySummaryBlockError === '' ? '' : 'border-red-600'}">
									<input id="all-industry-summary-block" name="all_industry_summary_block" bind:checked={allIndustrySummaryBlock} type="checkbox" class="w-5"/>
									<label for="all-industry-summary-block">All Industry Summary Block</label>
									<p class='error-text {allIndustrySummaryBlockError === '' ? 'hidden' : ''}'>{allIndustrySummaryBlockError}</p>
								</div>
							</div> -->
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {openCasesOnlyError === '' ? '' : 'border-red-600'}">
									<input id="open-cases-only" name="open_cases_only" bind:checked={openCasesOnly} type="checkbox" class="w-5"/>
									<label for="open-cases-only">Agency C</label>
									<p class='error-text {openCasesOnlyError === '' ? 'hidden' : ''}'>{openCasesOnlyError}</p>
								</div>
							</div>
						</div>

						<div class='input'>
							<div class="relative">
								<input id="new-agency" name="new_agency" bind:value={targetOrganization} placeholder="Add New Agency" class="peer z-20 placeholder:text-transparent {targetOrganizationError === '' ? '' : 'border-red-600'}"/>
								<label for="new-agency" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Add New Agency</label>
							</div>
							<p class="error-text {targetOrganizationError === '' ? 'hidden' : ''}">{targetOrganizationError}</p>
						</div>

						<!--
						<div class="flex space-x-4">
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {includeTablesError === '' ? '' : 'border-red-600'}">
									<input id="include-tables" name="include_tables" bind:checked={includeTables} type="checkbox" class="w-5"/>
									<label for="include-tables">Include Tables</label>
									<p class='error-text {includeTablesError === '' ? 'hidden' : ''}'>{includeTablesError}</p>
								</div>
							</div>
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {includeSummariesError === '' ? '' : 'border-red-600'}">
									<input id="include-summaries" name="include_summaries" bind:checked={includeSummaries} type="checkbox" class="w-5"/>
									<label for="include-summaries">Include Summaries</label>
									<p class='error-text {includeSummariesError === '' ? 'hidden' : ''}'>{includeSummariesError}</p>
								</div>
							</div>
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {onlySigSummariesError === '' ? '' : 'border-red-600'}">
									<input id="only-sig-summaries" name="only_sig_summaries" bind:checked={onlySigSummaries} type="checkbox" class="w-5"/>
									<label for="only-sig-summaries">Only Sig Summaries</label>
									<p class='error-text {onlySigSummariesError === '' ? 'hidden' : ''}'>{onlySigSummariesError}</p>
								</div>
							</div>
						</div>
						<div class="flex space-x-4">
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {includeTopViolTablesError === '' ? '' : 'border-red-600'}">
									<input id="include-top-viol-tables" name="include_top_viol_tables" bind:checked={includeTopViolTables} type="checkbox" class="w-5"/>
									<label for="include-top-viol-tables">Include Top Viol Tables</label>
									<p class='error-text {includeTopViolTablesError === '' ? 'hidden' : ''}'>{includeTopViolTablesError}</p>
								</div>
							</div>
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {useAssumptionsError === '' ? '' : 'border-red-600'}">
									<input id="use-assumptions" name="use_assumptions" bind:checked={useAssumptions} type="checkbox" class="w-5"/>
									<label for="use-assumptions">Use Assumptions</label>
									<p class='error-text {useAssumptionsError === '' ? 'hidden' : ''}'>{useAssumptionsError}</p>
								</div>
							</div>
							<div class="input inline-block w-1/3">
								<div class="flex my-auto text-lg space-x-4 {inferByNaicsError === '' ? '' : 'border-red-600'}">
									<input id="infer-by-naics" name="infer_by_naics" bind:checked={inferByNaics} type="checkbox" class="w-5"/>
									<label for="infer-by-naics">Infer By NAICS</label>
									<p class='error-text {inferByNaicsError === '' ? 'hidden' : ''}'>{inferByNaicsError}</p>
								</div>
							</div>
						</div>
						-->

						<!-- <input id="signatories-report" name="signatories_report" bind:checked={signatoriesReport} type="checkbox" class="hidden"/> -->
						<br> <!-- Spacing -->
						<input type="submit" value="Submit" disabled={submitted}
							class="w-4/12 pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 disabled:text-white hover:bg-blue-700 cursor-pointer disabled:cursor-wait text-white font-semibold border-none shadow-sm">
					</div>
				</form>
			</div>

			<!--**MOBILE**-->
			<div class="block md:hidden"> 
				<p class="text-2xl font-semibold text-blue-900 mb-8">Agency Agenda Search</p>
				<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
				<form method="POST" class="h-full relative" bind:this={searchForm} on:submit|preventDefault={handleSubmit}>
					<div class="flex flex-col space-y-4 text-xl">
						<div class='input'>
							<div class="relative">
								<input id="target-organization" name="target_organization" bind:value={targetOrganization} placeholder="Target Organization (Optional)" class="peer z-20 placeholder:text-transparent {targetOrganizationError === '' ? '' : 'border-red-600'}"/>
								<label for="target-organization" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Target Agency (optional)</label>
							</div>
							<p class="error-text {targetOrganizationError === '' ? 'hidden' : ''}">{targetOrganizationError}</p>
						</div>
						<!--
						<fieldset class="flex-col space-y-2">
							<div class="flex space-x-2">
								<div class='input w-1/2'>
									<div class="relative">
										<input id="start-date-mobile" name="YEAR_START" bind:value={yearStart} placeholder="Start Date" type='date' class="input-field mt-4 {yearStartError === '' ? '' : 'border-red-600'}"/>
										<label for="start-date-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-2 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Start Date</label>
									</div>									
									<p class='error-text {yearStartError === '' ? 'hidden' : ''}'>{yearStartError}</p>
								</div>
								<p class="my-auto">-</p> 
								<div class='input w-1/2'>
									<div class="relative">
										<input id="end-date-mobile" name="YEAR_END" bind:value={yearEnd} placeholder="End Date" type='date' class="input-field mt-4 {yearEndError === '' ? '' : 'border-red-600'}"/>
										<label for="end-date-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-2 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">End Date</label>
									</div>
									<p class='error-text {yearEndError === '' ? 'hidden' : ''}'>{yearEndError}</p>
								</div>
							</div>
						</fieldset>
						-->
						<!--
						<div class='input'>
							<div class="relative">
								<select id="target-state-mobile" name="target_state" bind:value={targetState} on:change={stateChange} class="input-field mt-4 w-full {targetStateError === '' ? '' : 'border-red-600'}">
									<option value="">Select a State</option>
									{#each states as state}
									<option value={state}>{state.replaceAll("_", " ")}</option>
									{/each}
								</select>
								<label for="target-state-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">State</label>
							</div>
							<p class='error-text {targetStateError === '' ? 'hidden' : ''}'>{targetStateError}</p>
						</div>
						-->
						<div class='input'>
							<div class="relative">
								<select id="target-county-mobile" name="target_county" bind:value={targetCounty} on:change={countyChange} class="input-field mt-4 w-full {targetCountyError === '' ? '' : 'border-red-600'}">
									<option value="">Select a County</option>
									{#each counties as county}
									<option value={county}>{county}</option>
									{/each}
								</select>
								<label for="target-county-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">County</label>
							</div>
							<p class='error-text {targetCountyError === '' ? 'hidden' : ''}'>{targetCountyError}</p>
						</div>
						<div class='input'>
							<div class="relative">
								<select id="target-agency-mobile" name="target_agency" bind:value={targetCity} class="input-field mt-4 w-full {targetCityError === '' ? '' : 'border-red-600'}">
									<option value="">Select an Agency Type</option> <!-- Zipcode is technical debt from API -->
									{#each zipcodes as zipcode}
										<option value={zipcode}>{zipcode.replaceAll("_", " ")}</option>
									{/each}
								</select>
								<label for="target-agency-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Agency</label>
							</div>
							<p class='error-text {targetCityError === '' ? 'hidden' : ''}'>{targetCityError}</p>
						</div>
						<div class='input'>
							<div class="relative">
								<select id="target-industry-mobile" name="target_industry" bind:value={targetIndustry} class="input-field mt-4 w-full {targetIndustryError === '' ? '' : 'border-red-600'}">
									<option value="">Select an Industry</option>
									{#each industries as industry}
										<option value={industry}>{industry}</option>
									{/each}
								</select>
								<label for="target-industry-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Industry</label>
							</div>
							<p class='error-text {targetIndustryError === '' ? 'hidden' : ''}'>{targetIndustryError}</p>
						</div>
						<input type="submit" value="Submit" disabled={submitted}
							class="max-w-xs pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 disabled:text-white hover:bg-blue-700 cursor-pointer disabled:cursor-wait text-white font-semibold border-none shadow-sm">
						
						<p class="text-2xl font-semibold text-blue-900 mb-8">Subregions</p>

						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {includeFedDataError === '' ? '' : 'border-red-600'}">
								<input id="include-fed-data-mobile" name="includeFedData" bind:checked={includeFedData} type="checkbox" class="w-5"/>
								<label for="include-fed-data-mobile">City A</label>
								<p class='error-text {includeFedDataError === '' ? 'hidden' : ''}'>{includeFedDataError}</p>
							</div>
						</div>
						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {includeStateJudgementsError === '' ? '' : 'border-red-600'}">
								<input id="include-state-judgements-mobile" name="includeStateJudgements" bind:checked={includeStateJudgements} type="checkbox" class="w-5"/>
								<label for="include-state-judgements-mobile">City B</label>
								<p class='error-text {includeStateJudgementsError === '' ? 'hidden' : ''}'>{includeStateJudgementsError}</p>
							</div>
						</div>
						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {includeStateCasesError === '' ? '' : 'border-red-600'}">
								<input id="include-state-cases-mobile" name="includeStateCases" bind:checked={includeStateCases} type="checkbox" class="w-5"/>
								<label for="include-state-cases-mobile">City C</label>
								<p class='error-text {includeStateCasesError === '' ? 'hidden' : ''}'>{includeStateCasesError}</p>
							</div>
						</div>

						<p class="text-2xl font-semibold text-blue-900 mb-8">Agencies</p>

						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {prevailingWageReportError === '' ? '' : 'border-red-600'}">
								<input id="prevailing-wage-report-mobile" name="prevailing_wage_report" bind:checked={prevailingWageReport} type="checkbox" class="w-5"/>
								<label for="prevailing-wage-report-mobile">Agency A</label>
								<p class='error-text {prevailingWageReportError === '' ? 'hidden' : ''}'>{prevailingWageReportError}</p>
							</div>
						</div>
						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {inferZipcodeError === '' ? '' : 'border-red-600'}">
								<input id="infer-zipcode-mobile" name="infer_zip" bind:checked={inferZipcode} type="checkbox" class="w-5"/>
								<label for="infer-zipcode-mobile">Agency B</label>
								<p class='error-text {inferZipcodeError === '' ? 'hidden' : ''}'>{inferZipcodeError}</p>
							</div>
						</div>
						<!-- <div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {allIndustrySummaryBlockError === '' ? '' : 'border-red-600'}">
								<input id="all-industry-summary-block-mobile" name="all_industry_summary_block" bind:checked={allIndustrySummaryBlock} type="checkbox" class="w-5"/>
								<label for="all-industry-summary-block-mobile">All Industry Summary Block</label>
								<p class='error-text {allIndustrySummaryBlockError === '' ? 'hidden' : ''}'>{allIndustrySummaryBlockError}</p>
							</div>
						</div> -->
						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {openCasesOnlyError === '' ? '' : 'border-red-600'}">
								<input id="open-cases-only-mobile" name="open_cases_only" bind:checked={openCasesOnly} type="checkbox" class="w-5"/>
								<label for="open-cases-only-mobile">Agency C</label>
								<p class='error-text {openCasesOnlyError === '' ? 'hidden' : ''}'>{openCasesOnlyError}</p>
							</div>
						</div>

						<div class='input'>
							<div class="relative">
								<input id="new-agency" name="new_agency" bind:value={targetOrganization} placeholder="Add New Agency" class="peer z-20 placeholder:text-transparent {targetOrganizationError === '' ? '' : 'border-red-600'}"/>
								<label for="new-agency" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Add New Agency</label>
							</div>
							<p class="error-text {targetOrganizationError === '' ? 'hidden' : ''}">{targetOrganizationError}</p>
						</div>

						<!--
						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {includeTablesError === '' ? '' : 'border-red-600'}">
								<input id="include-tables-mobile" name="include_tables" bind:checked={includeTables} type="checkbox" class="w-5"/>
								<label for="include-tables-mobile">Include Tables</label>
								<p class='error-text {includeTablesError === '' ? 'hidden' : ''}'>{includeTablesError}</p>
							</div>
						</div>
						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {includeSummariesError === '' ? '' : 'border-red-600'}">
								<input id="include-summaries-mobile" name="include_summaries" bind:checked={includeSummaries} type="checkbox" class="w-5"/>
								<label for="include-summaries-mobile">Include Summaries</label>
								<p class='error-text {includeSummariesError === '' ? 'hidden' : ''}'>{includeSummariesError}</p>
							</div>
						</div>
						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {onlySigSummariesError === '' ? '' : 'border-red-600'}">
								<input id="only-sig-summaries-mobile" name="only_sig_summaries" bind:checked={onlySigSummaries} type="checkbox" class="w-5"/>
								<label for="only-sig-summaries-mobile">Only Sig Summaries</label>
								<p class='error-text {onlySigSummariesError === '' ? 'hidden' : ''}'>{onlySigSummariesError}</p>
							</div>
						</div>
						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {includeTopViolTablesError === '' ? '' : 'border-red-600'}">
								<input id="include-top-viol-tables-mobile" name="include_top_viol_tables" bind:checked={includeTopViolTables} type="checkbox" class="w-5"/>
								<label for="include-top-viol-tables-mobile">Include Top Viol Tables</label>
								<p class='error-text {includeTopViolTablesError === '' ? 'hidden' : ''}'>{includeTopViolTablesError}</p>
							</div>
						</div>
						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {useAssumptionsError === '' ? '' : 'border-red-600'}">
								<input id="use-assumptions-mobile" name="use_assumptions" bind:checked={useAssumptions} type="checkbox" class="w-5"/>
								<label for="use-assumptions-mobile">Use Assumptions</label>
								<p class='error-text {useAssumptionsError === '' ? 'hidden' : ''}'>{useAssumptionsError}</p>
							</div>
						</div>
						<div class="input inline-block">
							<div class="flex my-auto text-lg space-x-4 {inferByNaicsError === '' ? '' : 'border-red-600'}">
								<input id="infer-by-naics-mobile" name="infer_by_naics" bind:checked={inferByNaics} type="checkbox" class="w-5"/>
								<label for="infer-by-naics-mobile">Infer By NAICS</label>
								<p class='error-text {inferByNaicsError === '' ? 'hidden' : ''}'>{inferByNaicsError}</p>
							</div>
						</div>
						-->

						<!--
						<input id="signatories-report" name="signatories_report" bind:checked={signatoriesReport} type="checkbox" class="hidden"/>
						<br>
						-->	
					</div>	
				</form>
			</div>
		</div>
	</div>
	<Footer/>
</main>

<style>
	main.background { 
		background-color:theme("colors.gray.100");
	}
	.input-field {
		@apply rounded-md shadow-sm font-thin py-1 px-2;
	}
</style>